import React from "react";
import { Drawer } from "antd";
import { useDispatch, useSelector } from "react-redux";
import {
  updateOpenModalCreateNewAdapter,
  updateAdapter,
  updateAdapterRefreshTable,
} from "../../../redux/adapters/adapterSlice";
import { BLANK_ADAPTER } from "../../../constants/adapter";
import { RootState } from "../../../app/store";
import AdapterEditor from "./AdapterEditor";
import { FormAction } from "../../../types/enums";
import { formatUuidT } from "../../../flatbuffers/display";

export default function AdapterEditorDrawer() {
  const dispatch = useDispatch();
  const {
    openModalCreateNewAdapter,
    formCreateEdit,
    adapter: selectedAdapter,
  } = useSelector((state: RootState) => state.adapter);

  let formAction: "create" | "edit" | "duplicate" = "create";
  if (formCreateEdit === FormAction.Edit) {
    formAction = "edit";
  } else if (formCreateEdit === FormAction.Duplicate) {
    formAction = "duplicate";
  }

  const existingAdapterId =
    formAction !== "create" ? formatUuidT(selectedAdapter.id) || undefined : undefined;

  const handleClose = () => {
    dispatch(updateOpenModalCreateNewAdapter(false));
    dispatch(updateAdapter({ ...BLANK_ADAPTER }));
  };

  const handleSaveSuccess = () => {
    dispatch(updateAdapterRefreshTable(true));
    handleClose();
  };

  return (
    <Drawer
      width="800"
      placement="right"
      onClose={handleClose}
      closable={false}
      open={openModalCreateNewAdapter}
    >
      <AdapterEditor
        mode="drawer"
        existingAdapterId={existingAdapterId}
        formAction={formAction}
        onSaveSuccess={handleSaveSuccess}
        onCancel={handleClose}
      />
    </Drawer>
  );
}
